// extracted by mini-css-extract-plugin
module.exports = {"title":"Confirm_title__1QLeM","body":"Confirm_body__3-O-Q","btnContainer":"Confirm_btnContainer__3bkrt","button":"Confirm_button__3IqOI"};